import { QueryClient } from '@tanstack/react-query';
import { createAsyncStoragePersister } from '@tanstack/query-async-storage-persister';
import type { Persister } from '@tanstack/query-persist-client-core';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 1000 * 60 * 60 * 24, // 24 hours
    },
  },
});

/**
 * filters out class instances (non-plain objects) from the persisted data.
 * This prevents non-serializable values like ChartRenderer from breaking
 * localStorage persistence
 */
function serializeReplacer(_key: string, value: unknown): unknown {
  if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
    const proto = Object.getPrototypeOf(value) as object | null;
    if (proto !== null && proto !== Object.prototype) {
      return undefined;
    }
  }
  return value;
}

export const persister: Persister = createAsyncStoragePersister({
  storage: window.localStorage,
  key: 'tb360',
  serialize: client => JSON.stringify(client, serializeReplacer),
});
